/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AccommodationListingsPositionSimulation_PositionOnListing_jsonld = {
    readonly '@context'?: string | Record<string, any>;
    readonly '@id'?: string;
    readonly '@type'?: string;
    listingType?: AccommodationListingsPositionSimulation_PositionOnListing_jsonld.listingType;
    listingId?: string;
    position?: number | null;
    listingTotalCount?: number | null;
};
export namespace AccommodationListingsPositionSimulation_PositionOnListing_jsonld {
    export enum listingType {
        CITY = 'city',
        REGION = 'region',
    }
}
